module.exports = __webpack_public_path__ + "static/img/3dcartoon2.47e9af5a.png";